import { useLayoutEffect } from 'react'

// This hook will ensure that the highlighted/selected element in a scrollable viewport
// is visible. `containerRef` should be a ref pointing to the scrollable viewport, and
// the dependencies array is an array of dependencies like you might pass to useLayoutEffect
// that determines when the selected element has changed.
//
// The highlighted element must have a data-is-highlighted attribute set to the string "true".
export const useScrollHighlightedElementIntoView = (
    containerRef: React.MutableRefObject<HTMLElement | null>,
    dependencies: readonly unknown[]
) => {
    useLayoutEffect(() => {
        const container = containerRef.current
        if (container === null) {
            return
        }

        const highlightedOptionElement = container.querySelector("[data-is-highlighted='true']")
        if (highlightedOptionElement === null) {
            return
        }

        const optionBoundingRect = highlightedOptionElement.getBoundingClientRect()
        const containerBoundingRect = container.getBoundingClientRect()
        if (optionBoundingRect.y < containerBoundingRect.y) {
            highlightedOptionElement.scrollIntoView({ block: 'start' })
        }
        else if (
            optionBoundingRect.y + optionBoundingRect.height >
            containerBoundingRect.y + containerBoundingRect.height
        ) {
            highlightedOptionElement.scrollIntoView({ block: 'end' })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies)
}
